import { IconInfoCircleFilled } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import RenderIf from 'components/RenderIf/RenderIf';
import { UncontrolledTooltip } from 'reactstrap';
import './ExecutiveSummaryCard.scss';
import { ISummaryItem } from './types';

const SummaryItem = ({ id, label, value, isNegative, tooltip }: ISummaryItem) => {
    const confidenceId = `${id}-confidence`;

    return (
        <div className="d-flex justify-content-between mt-1">
            <div className="text-muted">{label}</div>
            <div className={isNegative ? 'text-muted' : 'text-dark'}>
                <RenderIf isTrue={!!tooltip}>
                    <NSIcon id={confidenceId} icon={IconInfoCircleFilled} className="mr-1 text-muted" />
                    <UncontrolledTooltip target={confidenceId}>{tooltip}</UncontrolledTooltip>
                </RenderIf>
                {isNegative ? `(${value})` : value}
            </div>
        </div>
    );
};

export default SummaryItem;
